import type { ValidationCheck } from '../../types/checks.js';
import { expressionCheck } from '../expressionCheck.js';
import { mouthCheck } from '../mouthCheck.js';
import { hairOcclusionCheck } from '../hairOcclusionCheck.js';
import { headwearCheck } from '../headwearCheck.js';
import { faceObstructionCheck } from '../faceObstructionCheck.js';
import { redEyeCheck } from '../redEyeCheck.js';

/**
 * Face checks: what the person is doing and what covers the face.
 *
 * `expression`, `mouth`, `red_eye`, `hair_occlusion`, `headwear` and
 * `face_obstruction`. Each one is an independent module with its own id; this
 * file only lists them, so adding a face check touches exactly one line here.
 */
export const FACE_CHECKS: readonly ValidationCheck[] = [
  expressionCheck,
  mouthCheck,
  hairOcclusionCheck,
  headwearCheck,
  faceObstructionCheck,
  redEyeCheck,
];
